import { ApolloClient } from '@apollo/client/core';
import { FETCH_PARENT_REGISTRATION } from '@/graphql/account/queries';
import { redirect } from '@/helpers/redirects';

export default async function redirectParentRegistration(apolloClient: ApolloClient<any>) {
  try {
    const { data } = await apolloClient.query({
      query: FETCH_PARENT_REGISTRATION,
      fetchPolicy: 'cache-first',
    });
    const { postalAddress, careType } = data.parentRegistration;
    const { pathname, search } = new URL(window.location.href);
    const returnPath = pathname + search;

    if (!postalAddress) {
      redirect(`/registration/location?returnPath=${encodeURIComponent(returnPath)}`);
      return;
    }
    if (!careType && window.location.pathname === '/account/seekers/dashboard') {
      redirect('/registration/care_type');
    }
  } catch (err) {
    console.error('Error fetching parent registration:', err);
    throw err;
  }
}
